import type { ReactElement } from 'react';
import { Navigate, Outlet } from 'react-router';

import { ErrorState } from '../components/ui/ErrorState.js';
import { Button } from '../components/ui/Button.js';
import { errorText } from '../components/ui/error-text.js';
import { Spinner } from '../components/ui/Spinner.js';
import { useMe } from '../hooks/useMe.js';
import { routePaths } from './route-paths.js';

export function RequireFamily(): ReactElement {
    const me = useMe();

    if (me.isPending) {
        return <Spinner label="Loading your account" />;
    }
    if (me.isError) {
        return (
            <ErrorState
                title="Could not load your account"
                description={errorText(me.error)}
                action={
                    <Button
                        onClick={() => {
                            void me.refetch();
                        }}
                    >
                        Try again
                    </Button>
                }
            />
        );
    }
    if (me.data.families.length === 0) {
        return <Navigate to={routePaths.onboarding} replace />;
    }
    return <Outlet />;
}
